import commonMixin from '../../../mixins/_common';
import partsMixin from '../_parts_mixin';
import tableEditor from '../../../components/_table_editor';

// 表パーツの見出し背景色定義
const TABLE_PARTS_HEADER_BG_COLOR = {
    ENABLE: '#F5F5F5',
    DISABLE: 'none',
};

// 表パーツデザインパターン一覧
const TABLE_DESING_PATTERN_PATH = 'common/parts/table_design/';
const TABLE_DESING_PATTERN = [
    'default',
    'bgwhite',
    'autowidth'
];

/**
 * パーツ編集コンポーネント「表パーツ」
 */
export default {
    template: '#parts_edit_table_template',
    data() {
        return {
            designPatternPath: TABLE_DESING_PATTERN_PATH,
            designPattern: TABLE_DESING_PATTERN
        };
    },
    props: ['parts_data', 'type', 'edit_id', 'device_sync'],
    computed: {
        // 行の見出しへ色をつけるフラグ
        rowHeaderEnable: {
            get() {
                return (this.parts_data.row_header_bg_color.toLowerCase() !== TABLE_PARTS_HEADER_BG_COLOR.DISABLE);
            },
            set(bool) {
                this.parts_data.row_header_bg_color = bool ? TABLE_PARTS_HEADER_BG_COLOR.ENABLE : TABLE_PARTS_HEADER_BG_COLOR.DISABLE;
            },
        },
        // 列の見出しへ色をつけるフラグ
        colHeaderEnable: {
            get() {
                return (this.parts_data.col_header_bg_color.toLowerCase() !== TABLE_PARTS_HEADER_BG_COLOR.DISABLE);
            },
            set(bool) {
                this.parts_data.col_header_bg_color = bool ? TABLE_PARTS_HEADER_BG_COLOR.ENABLE : TABLE_PARTS_HEADER_BG_COLOR.DISABLE;
            },
        }
    },
    mixins: [commonMixin, partsMixin],
    components: {
        // 表設定編集コンポーネント
        'table-editor': tableEditor,
    }
};
